import i18next from 'i18next';
import en from '../lang/en.json';
import es from '../lang/es.json';
import it from '../lang/it.json';
import ja from '../lang/ja.json';
import ko from '../lang/ko.json';
import zh from '../lang/zh.json';

i18next.init({
  lng: 'zh-CN', // 默认语言
  fallbackLng: 'zh-CN',
  resources: {
    "en-US": { translation: en },
    "zh-CN": { translation: zh },
    "ja": { translation: ja },
    "es": { translation: es },
    "ko": { translation: ko },
    "it": { translation: it }
  }
});



export default i18next;
